/* eslint-disable import/prefer-default-export */
export const OPEN_PAGE = 'OPEN_PAGE'
